module.exports = __webpack_public_path__ + "img/marker.765f7c93.png";